import script from "./StylingAndComfortStandard.vue?vue&type=script&setup=true&lang=js"
export * from "./StylingAndComfortStandard.vue?vue&type=script&setup=true&lang=js"

import "./StylingAndComfortStandard.vue?vue&type=style&index=0&id=6a9ff678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9ff678"]])

export default __exports__